import React from 'react';
import withIcon from '../utilities/withIcon';

const IconList = () => {
  return (
    <g>
      <path d="M15.254 13.5c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 14.254v-.008c0-.412.334-.746.746-.746h14.508zm0-4.15c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 10.104v-.008c0-.412.334-.746.746-.746h14.508zm0-4.2c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 5.904v-.008c0-.412.334-.746.746-.746h14.508zm0-4.15c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 1.754v-.008C0 1.334.334 1 .746 1h14.508z" />
    </g>
  );
};

export default withIcon(IconList);
